import { Node, NodeSelection } from 'tiptap'

export default class CodeEmbed extends Node {
  get name() {
    return 'codeEmbed'
  }

  get schema() {
    return {
      attrs: {
        src: {
          default: null,
        },
        width: {
          default: '100%',
        },
        height: {
          default: 450,
        },
      },
      group: 'block',
      selectable: true,
      parseDOM: [
        {
          tag: 'iframe.motyro-embed__Iframe',
          getAttrs: (dom) => ({
            src: dom.getAttribute('src'),
            width: dom.getAttribute('width'),
            height: dom.getAttribute('height'),
          }),
        },
      ],
      toDOM: (node) => [
        'div',
        { class: 'motyro-embed' },
        [
          'div',
          { class: 'motyro-embed__Content' },
          [
            'iframe',
            {
              class: 'motyro-embed__Iframe',
              src: node.attrs.src,
              frameborder: 0,
              allowfullscreen: 'true',
              allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
              // You can set the width and height here also
              width: node.attrs.width,
              height: node.attrs.height,
            },
          ],
        ],
      ],
    }
  }

  get view() {
    return {
      props: ['node', 'updateAttrs', 'view', 'selected', 'getPos'],
      computed: {
        src: {
          get() {
            return this.node.attrs.src
          },
          set(src) {
            this.updateAttrs({
              src,
            })
          },
        },
        styles: {
          get() {
            return {
              height: this.node.attrs.height,
              width: this.node.attrs.width,
            }
          },
          set(obj) {
            this.updateAttrs(obj)
          },
        },
      },
      methods: {
        onResize() {
          const height = this.$refs.iframeBox.clientHeight + 2
          const width = this.$refs.iframeBox.clientWidth + 2

          const obj = {
            height,
            width,
          }

          this.styles = obj
        },
        updateSource(event) {
          this.src = event.target.value
        },
        makeNodeSelection() {
          let tr = this.view.state.tr
          const pos = this.getPos()
          let pos1 = this.view.state.doc.resolve(pos)
          let selection = new NodeSelection(pos1)
          tr.setSelection(selection)
          this.view.dispatch(tr)
        },
      },
      template: `
        <div class="motyro-embed" :class="{ 'is-Selected': selected }" ref="iframeBox" @click="makeNodeSelection" @mouseup="onResize" :style="{ width: styles.width + 'px', height: styles.height + 'px' }">
          <iframe class="motyro-embed__Iframe" :src="src"></iframe>
          <input class="motyro-embed__Input" @paste.stop type="text" v-model="src" v-if="view.editable" />
        </div>
      `,
    }
  }

  commands({ type }) {
    return (attrs) => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
}
